import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { navStore, useStore, } from '@mcn-platform/models';
import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { WysiwygViewer } from '../../publisher/wysiwyg/WysiwygEditor';
const limitToPageWidth = true;
const MemberDetails = observer(({ member, portal }) => {
    if (member.status === 'ACTIVE') {
        return (_jsx(Box, { children: _jsx(WysiwygViewer, { id: member.membership?.id, value: member.membership?.confirmationMessage?.slate
                    || portal.defaultCheckoutConfirmationMessage?.slate }) }));
    }
    return (_jsx("h2", { children: "There was a problem with your order." }));
});
const Confirm = () => {
    const [searchParams] = useSearchParams(); // new URLSearchParams(window.location.search);
    const newMemberID = searchParams.get('memberID');
    const store = useStore();
    const { currentPortal } = store;
    const [member, setMember] = useState();
    useEffect(() => {
        const verifyCheckout = async () => {
            if (!newMemberID) {
                navStore.clearBlockInput();
                return;
            }
            console.log('show dialog');
            navStore.showBlockInput();
            const response = await store.verifyCheckout(newMemberID);
            console.log('confirm response', response);
            const membership = await store.load('membership', response.member.membership?.id);
            if (response.statusCode === 200) {
                console.log('Successfully verified checkout', membership);
                const value = membership.conversionValue();
                console.log('Logging trackdesk conversion', value);
                setMember(response.member);
                if (currentPortal.trackDeskTenantId) {
                    // @ts-expect-error on trackdesk
                    const { trackdesk } = window;
                    if (trackdesk) {
                        trackdesk(currentPortal.trackDeskTenantId, 'conversion', {
                            conversionType: 'sale',
                            amount: {
                                value,
                            },
                        });
                    }
                    else {
                        console.log('trackdesk method not found');
                    }
                }
            }
            navStore.clearBlockInput();
        };
        if (member) {
            // nothing to do here
            navStore.clearBlockInput();
            return;
        }
        if (newMemberID) {
            // verify this member
            verifyCheckout().then(() => console.log('confirm done'));
        }
    }, [store, member, newMemberID, currentPortal?.trackDeskTenantId]);
    return (_jsx(Box, { sx: {
            ...(limitToPageWidth && {
                width: '100%',
                maxWidth: 1200,
                marginX: 'auto',
            }),
        }, children: member ? (_jsx(MemberDetails, { member: member, portal: currentPortal })) : (_jsx("div", { children: "Confirming..." })) }));
};
Confirm.defaultProps = {};
Confirm.meta = {
    group: 'commerce',
    name: 'Checkout Confirm',
    description: 'Confirms Checkout Session for specificed course, program or membership.',
    props: [
    // read from querystring, at least for now
    // {
    //   key: 'memberID',
    //   name: 'Membership ID',
    //   type: 'string',
    //   description: 'The ID of the member record to verify.',
    // },
    ],
    defaultConfig: {
        type: 'component',
        component: 'Confirm',
        props: {
        // props: {
        //   checkoutTypes: '@checkoutTypes',
        //   checkoutIDs: '@checkoutIDs',
        // },
        },
    },
};
export default observer(Confirm);
//# sourceMappingURL=Confirm.js.map